import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { FooterComponent, NavigationBar } from '../components'
import { AboutPage, ContactPage, FreeProjectPage, HomePage, OurClientPage, ServicePage } from '../pages'

const MainRoute = () => {
    return (
        <>
            <NavigationBar/>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicePage />} />
                <Route path="/our-clients" element={<OurClientPage />} />
                <Route path="/free-projects" element={<FreeProjectPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/about" element={<AboutPage />} />
            </Routes>
            <FooterComponent/>
        </>
    )
}

export default MainRoute